"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoholeArea = void 0;
const TileType_1 = require("../../TileType");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SpaceType_1 = require("../../SpaceType");
const Tags_1 = require("../Tags");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class MoholeArea extends Card_1.Card {
    constructor(name = CardName_1.CardName.MOHOLE_AREA, adjacencyBonus = undefined, metadata = {
        cardNumber: '142',
        renderData: CardRenderer_1.CardRenderer.builder((b) => {
            b.production((pb) => pb.heat(4).digit).br;
            b.tile(TileType_1.TileType.MOHOLE_AREA, true);
        }),
        description: 'Increase your heat production 4 steps. Place this tile ON AN AREA RESERVED FOR OCEAN.',
    }) {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name,
            tags: [Tags_1.Tags.BUILDING],
            cost: 20,
            adjacencyBonus,
            metadata,
            productionBox: Units_1.Units.of({ heat: 4 }),
        });
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select an ocean space for special tile', player.game.board.getAvailableSpacesForOcean(player), TileType_1.TileType.MOHOLE_AREA, (space) => {
            player.game.addTile(player, SpaceType_1.SpaceType.OCEAN, space, { tileType: TileType_1.TileType.MOHOLE_AREA });
            space.adjacency = this.adjacencyBonus;
            player.addProduction(Resources_1.Resources.HEAT, 4);
            return undefined;
        });
    }
}
exports.MoholeArea = MoholeArea;
//# sourceMappingURL=MoholeArea.js.map